import { generateClient } from "aws-amplify/api";
import { updateFormTemplate } from "../graphql/mutations";
import { recordSentry } from "utils/recordSentry";
import { FormTemplateForResolver } from "db/definitions";

export default async function _updateFormTemplate(
	formTemplate: Pick<FormTemplateForResolver, "id" | "template"> & Partial<FormTemplateForResolver>,
): Promise<void> {
	try {
		const client = generateClient({ authMode: "userPool" });
		await client.graphql({
			query: updateFormTemplate,
			variables: {
				input: formTemplate,
			},
			authMode: "userPool",
		});
	} catch (error) {
		recordSentry({ error, msg: "Caught an error updating formTemplate:" });
	}
}
